<template>
  <section>
    <a
        href="javascript:window.print()"
        class="tab_button tab_button_print"
        :title="'Tisknout' | translate">Tisknout
    </a>
    <table class="vypis lower_row">
      <thead class="no_sortable">
      <tr class="scrollable_header">
        <th></th>
        <th v-translate>Název kanálu</th>
        <th class="center" v-translate>Set-top box</th>
        <th class="center" v-translate>Second Screen</th>
      </tr>
      </thead>
      <tbody class="rowspan" v-for="thematicChannelPackage in thematicChannelPackages" :key="thematicChannelPackage.id">
      <tr v-for="(channel, channelIndex) in thematicChannelPackage.channels" :key="channelIndex">
        <td :data-th="'Název balíčku' | translate" class="first_data package_name"
            :rowspan="thematicChannelPackage.channels.length" v-if="channelIndex === 0">
          {{ thematicChannelPackage.name }}
        </td>
        <td :data-th="'Název kanálu' | translate">
          <entity-link :id="channel.id" type="channel">{{ channel.name }}</entity-link>
        </td>
        <td :data-th="'Set-top box' | translate" class="center">
          <img
              class="is_set"
              src="../../../../assets/images/is-set.svg"
              :alt="'Ano' | translate"
              v-if="!channel['device_group_restrictions']['stb']">
        </td>
        <td :data-th="'Second Screen' | translate" class="center">
          <span class="second_screen_icon" v-if="!channel['device_group_restrictions']['mobile']">
            <img class="is_set" src="../../../../assets/images/mobile.svg" :alt="'Ano' | translate">
          </span>
          <span class="second_screen_icon" v-if="!channel['device_group_restrictions']['web']">
            <img class="is_set" src="../../../../assets/images/web.svg" :alt="'Ano' | translate">
          </span>
        </td>
      </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import EntityLink from "../../../common/EntityLink.vue";

export default {
  name: "ThematicPackages",
  components: { EntityLink },
  props: {
    thematicChannelPackages: [Array, Object]
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/downloads/thematic-packages/ThematicPackages.vue